<template>
  <div v-if="!loading" class="card" style="max-height:400px;overflow-y:auto;">
    <div v-if="data && data.length" class="card-body p-2">
      <ul class="nav">
        <li
          class="nav-item"
          v-for="(item, index) in data"
          v-bind:key="item.id + Math.random(1024)"
          :ref="type + `${index}`"
        >
          <a
            class="nav-link"
            @click="() => handleClick(item)"
            tabindex="-1"
            :id="type + `${index}`"
            @keyup.enter="() => handleClick(item)"
            @keyup.40="() => focusTo(index + 1)"
            @keyup.38="() => focusTo(index - 1)"
          >
            <div class="left">
              <h5 :class="item.kategori ? '' : 'mb-0'">
                {{ item.kode }} | {{ item.nama }}
              </h5>

              <span v-if="item.kategori" class="item-label mb-0">{{
                item.kategori
              }}</span>
            </div>
            <div class="right">
              <h5 class="mb-0 text-success text-right">
                {{ item.formatted_biaya || item.formatted_harga }}
              </h5>
              <del
                class="block text-right text-muted"
                v-if="
                  (item.biaya && item.biaya != item.biaya_awal) ||
                    (item.harga && item.harga != item.harga_awal)
                "
              >
                {{
                  item.biaya_awal
                    ? convertToRupiah(item.biaya_awal)
                    : convertToRupiah(item.harga_awal)
                }}
              </del>
              <small
                class="text-danger text-right block"
                v-if="item.formatted_diskon"
                >( - {{ item.formatted_diskon }} )</small
              >
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div v-else class="p-2">
      <center>tidak ditemukan hasil pencarian</center>
    </div>
  </div>
  <div v-else class="card">
    <div class="p-2">
      <center>Sedang melakukan pencarian..</center>
    </div>
  </div>
</template>
<style scoped>
.nav {
  width: 100%;
}
.card {
  position: absolute;
  width: 95.375%;
  z-index: 9999;
}
.nav-item {
  width: 100%;
}
.nav-link {
  margin-right: 0;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}
.nav-item:last-child .nav-link {
  margin-right: 0;
  margin-bottom: 0;
}
.nav-link:hover,
.nav-link:focus {
  background: rgba(22, 160, 133, 0.12);
}
</style>
<script>
import { convertToRupiah } from "@/data/helper.js";
export default {
  name: "SearchResult",
  components: {},
  props: {
    data: Array,
    type: String,
    loading: Boolean,
  },
  data: function() {
    return {
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    handleClick(item) {
      this.$emit("addItem", item);
    },
    focusTo(index) {
      // //console.log(index);
      if (index > -1 && index < this.data.length) {
        document.getElementById(`${this.type}${index}`).focus();
      }
    },
  },
};
</script>
